<template>
    <div class="page-order page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="24">
                    <h3 style="float: none;">产品供应列表</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>订单管理</el-breadcrumb-item>
                            <el-breadcrumb-item>待完成列表</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
            </el-row>
            <div class="bd">
                <div class="search-block content-body">
                    <el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline" @submit.native.prevent>
						<el-form-item prop="desk_number" label="所属店铺：">
						    <el-select size="small" v-model="form_search.desk_number" placeholder="请选择" style="width:100%;">
						        <el-option
						                v-for="item in init_data.desk_list"
						                :key="item.number"
						                :label="item.name"
						                :value="item.number">
						        </el-option>
						    </el-select>
						</el-form-item>
						<el-form-item prop="product_sku_number" label="商品编码：" style="margin-bottom: 0;">
						    <el-input v-model="form_search.product_sku_number" size="small" placeholder="商品编码" clearable></el-input>
						</el-form-item>
                        <el-form-item label="日期：">
                            <el-date-picker
                                    size="small"
                                    clearable
                                    v-model="create_range"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item style="margin-bottom: 0;">
                            <el-button type="primary" class="search-btn"  size="medium" @click='searchList()'>查询</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-block content-body">
                    <div ref="contentBody">
                        <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;">
                            <el-table-column prop="finish_date" sortable="custom" align="center" label="日期" min-width="100">
                            </el-table-column>
							<el-table-column prop="desk_name" align="center" label="店铺名称" min-width="100">
                                <template slot-scope="scope">
                                    <my-textEllipsis v-if="is_refresh" :content="scope.row.desk_name"></my-textEllipsis>
                                </template>
                            </el-table-column>
							<el-table-column prop="product_sku_number" align="center" label="产品编号" min-width="100">
							</el-table-column>
							<el-table-column prop="product_name" align="center" label="产品名称" min-width="100">
							</el-table-column>
							<el-table-column prop="product_count" align="center" label="商品数量" min-width="80">
							</el-table-column>
							<el-table-column prop="paid_amount" align="center" label="订单实付" min-width="100">
								<template slot-scope="scope">
								    <span class="c-red">{{scope.row.paid_amount}}</span>
								</template>
							</el-table-column>
                        </el-table>
                    </div>
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="table_data.page_info.page"
                            :page-sizes="[10,30, 50,80,100]"
                            :page-size="table_data.page_info.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="table_data.page_info.total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'usercenter',
        data() {
            return {
                clientHeight:'',
                baseUrl:this.$client.IMG_URL,
                body_loading:false,
                is_refresh: true,
                create_range:'',
                form_search:{
                    desk_number:'',
					product_sku_number:'',
                    start_finish_date:'',
                    end_finish_date:''
                },
                init_data:{
					desk_list:[],
                },
                table_data:{
                    loading: false,
                    list:[],
                    page_info: {
                        page: 1,
                        pageSize: 10,
                        total: 130
                    }
                },
            }
        },
        created() {
            document.title = '产品供应列表';
            this.getList();
        },
        methods: {
            searchList(){
                var _this = this;
                _this.table_data.page_info.page = 1;
                _this.getList();
            },
            getList() {
                var _this = this;
                var params = _this.form_search;
                params.p = _this.table_data.page_info.page;
                params.pageSize = _this.table_data.page_info.pageSize;
                _this.table_data.loading = true;
				var desk_list = [{number:'', name: '全部'}];
                this.$client.get('/adminapi/orderstatis/supplierorderitems', params, function(res,message){
                    _this.table_data.list = res.list;
                    _this.table_data.page_info = res.pager;
					_this.init_data.desk_list = desk_list.concat(res.desk_name_list);
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
			handleSizeChange(val) {
			    this.table_data.page_info.pageSize = val;
			    this.getList();
			},
			handleCurrentChange(val) {
			    this.table_data.page_info.page = val;
			    this.getList();
			},
            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-394)+'px';
            },
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            },
            create_range(newVal){
                if(newVal == null){
                    this.form_search.start_finish_date = '';
                    this.form_search.end_finish_date = '';
                }else{
                    this.form_search.start_finish_date = newVal[0];
                    this.form_search.end_finish_date = newVal[1];
                }
            }
        }
    }
</script>
<style>

</style>
<style scoped>
    .status-2{
        color: #9a9a9a;
    }
    .status-1{
        color: #F31A5C;
    }
    .status-0{
        color: #F27918;
    }
    .status-3{
        color: #0C67F0;
    }
    .status-9{
        color: #04B365;
    }
    .status-10{
        color: #666;
    }
</style>